/**
 * Notification Preferences Use Cases Factory
 *
 * @module @personnel/composition/factories/createNotificationPreferencesUseCases
 */

import type { AxiosInstance } from 'axios';
import type { NotificationPreferencesUseCases } from '@personnel/composition/types';

import { createNotificationPreferencesApiRepository } from '@personnel/infrastructure/repositories/NotificationPreferencesApiRepository';
import { getNotificationPreferencesConfigUseCase } from '@personnel/application/use-cases/GetNotificationPreferencesConfigUseCase';

/**
 * Assembles the notification preferences use cases with their injected dependencies.
 *
 * @param httpClient - Axios instance for the connect API
 */
export const createNotificationPreferencesUseCases = (httpClient: AxiosInstance): NotificationPreferencesUseCases => {
  const apiPort = createNotificationPreferencesApiRepository({ httpClient });

  return {
    getConfig: getNotificationPreferencesConfigUseCase({ apiPort }),
  };
};
